import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontPlayfairDisplay } from "@product/scmp-sdk";

import { HeaderAllMenu } from "~/components/header/header-oneline-menu-container/header-all-menu";

export const StyledHeaderAllMenu = styled(HeaderAllMenu)``;

type Props = {
  $variant?: string;
};
export const Container = styled.div<Props>`
  display: flex;
  align-items: center;

  margin-block-start: 1px;
  margin-inline-start: 32px;

  ${props => {
    if (props.$variant === "style") {
      return css`
        ${StyledHeaderAllMenu} {
          > span {
            color: #222222;
            font-weight: normal;
            font-size: 14px;
            font-family: ${fontPlayfairDisplay};
          }
          > svg {
            path {
              fill: #222222;
            }
          }
        }
      `;
    }
  }}
`;

export const Divider = styled.span`
  margin-inline: 12px 6px;

  color: #001246;
  font-size: 15px;
  line-height: 18px;
`;
